// extracted by mini-css-extract-plugin
export var quantityInput = "_f4-0";